<template>
<v-app id="inspire">
  <!-- <ui-loader v-model="loading" /> -->
  <v-container fluid fill-height class="loginOverlay" mt-5>
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm4 elevation-6>
        <v-form @submit="login" v-model="valid" ref="loginForm" onSubmit="return false;">
          <v-card pt-5>
            <v-sheet class="v-sheet--offset mx-auto" color="blue-grey" elevation="12" max-width="calc(100% - 32px)" centered>
              <v-layout flex align-center justify-center py-3>

                <img src="@/assets/logoc.png" style="width:300px;height:auto;" />

                    </v-layout>
            </v-sheet>
            <v-card-text class="pt-0">
              <div>

                <v-text-field label="Usuario" v-model="username" :rules="usernameRules" required :solo="solo"></v-text-field>
                <v-text-field label="Contraseña" v-model="password" min="8" :append-icon="e1 ? 'visibility' : 'visibility_off'" @click:append="() => (e1 = !e1)" :type="e1 ? 'password' : 'text'" :rules="passwordRules" counter required :solo="solo"></v-text-field>

              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="submit" :class=" { 'blue-grey darken-2 white--text' : valid, disabled: !valid }">Iniciar</v-btn>

            </v-card-actions>
            <v-snackbar v-model="hasError" color="red lighten-2" :timeout="8000" :vertical="true" top>
              {{ errorMessage }}
              <v-btn dark flat @click="hasError = false">
                Cerrar
              </v-btn>
            </v-snackbar>

          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
  <v-footer color="blue-grey" class="white--text px-4 " app>
    <div>CatDaf</div>
    <v-spacer></v-spacer>
    <div>&copy; 2023</div>
    <div>&nbsp; v{{ productVersion }} </div>
  </v-footer>
</v-app>
</template>

<script>
import {
  AUTH_REQUEST,
} from '../../store/actions/auth';
import {
  USER_REQUEST,
} from '../../store/actions/user';
import {
  REQUEST_CURRENT_ROUTE,
} from '../../store/actions/route';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      hasError: false,
      loading: false,
      errorMessage: 'Error no especificado',
      valid: false,
      e1: false,
      password: '',
      passwordRules: [
        (v) => !!v || 'El password es requerido',
      ],
      username: '',
      usernameRules: [
        (v) => !!v || 'El usuario es requerido',
      ],
      e1: 'text',
      solo: true,
      loading: false,
    };
  },
  methods: {
    async login() {
      const {
        username,
        password,
      } = this;
      if (username === '' || password === '') {
        this.hasError = true;
        this.errorMessage = 'Proporcione el usuario y la contraseña';
        return;
      }
      try {
        this.loading = true;
        await this.$store.dispatch(AUTH_REQUEST, {
            username,
            password,
          })
          .then((result) => {
            this.hasError = false;
          });

        await this.$store.dispatch(USER_REQUEST, {
            authToken: this.$store.state.auth.token,
          });
        // await this.$store.dispatch(REQUEST_CURRENT_ROUTE);
        let home = this.$store.state.user.profile.home;
        if (!home) {
          home = '/products';
        }
        this.$router.push(home);
      } catch (error) {
        let errorType = '';
        this.hasError = true;
        if (error.response) {
          if (error.response.data.error) {
            errorType = error.response.data.error;
          } else if (error.response.data.message) {
            errorType = error.response.data.message;
          }
          this.errorMessage = errorType;
        } else if (error.message) {
          this.errorMessage = error.message;
        }

        // Translate errors
        if (errorType === 'invalid_grant') {
          this.errorMessage = 'Usuario o contraseña incorrectos';
        } else if (this.errorMessage === 'Network Error') {
          this.errorMessage = 'Error de Red: revise su conexión a internet';
        }
        return;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    productVersion() {
      return JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version;
    },
  },
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
